import { IComponentOptions } from 'angular';

export const NoSupportsComponent: IComponentOptions = {
  template: require('./no-supports.html'),
  controller() {
    // empty block?
  },
};

angular.module('nv.SupportsModule').component('noSupports', NoSupportsComponent);
